package com.wintermar.inspection.core.ui.component.location

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.component.input.InputText
import com.wintermar.inspection.core.ui.component.input.util.InputState
import com.wintermar.inspection.core.ui.component.input.util.InputStateModel
import com.wintermar.inspection.core.ui.component.location.util.LocationModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import kotlinx.coroutines.flow.collectLatest

@Composable
fun Location(
    address: String = "",
    padding: Dp = LocalAppTheme.current.dimension.spacing.space4,
    onChanged: (String, LocationModel?) -> Unit
) {
    val scope = rememberCoroutineScope()
    val inputState = remember {
        InputState(
            initialData = InputStateModel(
                value = address,
                placeholder = "Type location"
            ), scope = scope
        )
    }
    var location by remember { mutableStateOf<LocationModel?>(null) }

    LaunchedEffect(inputState) {
        snapshotFlow { inputState.value.text }.collectLatest {
            onChanged(inputState.value.text.toString(), location)
        }
    }

    Column(
        modifier = Modifier.fillMaxWidth().padding(padding),
        verticalArrangement = Arrangement.spacedBy(padding),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        CurrentLocation(onClick = {
            location = it
            inputState.onSetValue(it?.locality ?: "")
            onChanged(inputState.value.text.toString(), location)
        })
        InputText(state = inputState, modifier = Modifier.fillMaxWidth())
    }
}

@Composable
expect fun CurrentLocation(onClick: (LocationModel?) -> Unit)
